export const FALLBACK_LANG = 'en-US';

// Traditional for Taiwan, Hong Kong, Macau and explicit Hant tags, otherwise
// Simplified.
const TRADITIONAL_CHINESE_PATTERN = /^zh-(tw|hk|mo|hant)\b/;

/**
 * Map a browser language tag (e.g. "es-MX", "zh-Hant-HK") to one of our
 * supported languages, or null when we don't support it.
 */
export const normalizeBrowserLang = (tag) => {
  if (typeof tag !== 'string' || !tag) return null;
  const lowerTag = tag.toLowerCase();
  switch (lowerTag.split('-')[0]) {
    case 'en':
      return 'en-US';
    case 'es':
      return 'es-US';
    case 'fr':
      return 'fr-CA';
    case 'zh':
      return TRADITIONAL_CHINESE_PATTERN.test(lowerTag) ? 'zh-TW' : 'zh-CN';
    case 'de':
      return 'de-DE';
    case 'ja':
      return 'ja-JP';
    case 'pt':
      return 'pt-BR';
    default:
      return null;
  }
};

/**
 * Pick the initial UI language: a previously chosen language wins, then the
 * first supported entry in the browser's preferred languages, then English.
 * A logged-in user's profile language is applied later by useAuth.
 */
export const detectLanguage = ({ stored, browserLanguages = [] }) => {
  const storedLang = normalizeBrowserLang(stored);
  if (storedLang) return storedLang;

  for (const tag of browserLanguages) {
    const lang = normalizeBrowserLang(tag);
    if (lang) return lang;
  }

  return FALLBACK_LANG;
};
